import axios from 'axios'
import { cloudinary } from 'config'

const client = axios.create({
  baseURL: `${cloudinary.api}/${cloudinary.cloudName}`,
})

export default client
